@file:OptIn(InternalResourceApi::class)

package ifaandroid.core.assets_bundle.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DensityQualifier
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/ifaandroid.core.assets_bundle.generated.resources/"

@delegate:ResourceContentHash(1_116_741_472)
public val Res.drawable.almost_done: DrawableResource by lazy {
      DrawableResource("drawable:almost_done", setOf(
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/almost_done.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/almost_done.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/almost_done.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_955_029_304)
public val Res.drawable.bland_notification_icon_android: DrawableResource by lazy {
      DrawableResource("drawable:bland_notification_icon_android", setOf(
        ResourceItem(setOf(), "${MD}drawable/bland_notification_icon_android.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_752_011_059)
public val Res.drawable.bland_notification_icon_ios: DrawableResource by lazy {
      DrawableResource("drawable:bland_notification_icon_ios", setOf(
        ResourceItem(setOf(), "${MD}drawable/bland_notification_icon_ios.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_315_612_618)
public val Res.drawable.calc_plan_header: DrawableResource by lazy {
      DrawableResource("drawable:calc_plan_header", setOf(
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/calc_plan_header.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/calc_plan_header.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/calc_plan_header.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_014_402_944)
public val Res.drawable.cali_notification_icon_android: DrawableResource by lazy {
      DrawableResource("drawable:cali_notification_icon_android", setOf(
        ResourceItem(setOf(), "${MD}drawable/cali_notification_icon_android.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-896_132_696)
public val Res.drawable.cali_notification_icon_ios: DrawableResource by lazy {
      DrawableResource("drawable:cali_notification_icon_ios", setOf(
        ResourceItem(setOf(), "${MD}drawable/cali_notification_icon_ios.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-442_870_766)
public val Res.drawable.carnivore_notification_icon_android: DrawableResource by lazy {
      DrawableResource("drawable:carnivore_notification_icon_android", setOf(
        ResourceItem(setOf(), "${MD}drawable/carnivore_notification_icon_android.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_522_523_020)
public val Res.drawable.carnivore_notification_icon_ios: DrawableResource by lazy {
      DrawableResource("drawable:carnivore_notification_icon_ios", setOf(
        ResourceItem(setOf(), "${MD}drawable/carnivore_notification_icon_ios.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_620_394_146)
public val Res.drawable.chef_w: DrawableResource by lazy {
      DrawableResource("drawable:chef_w", setOf(
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/chef_w.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/chef_w.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/chef_w.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_267_415_879)
public val Res.drawable.coach_intro: DrawableResource by lazy {
      DrawableResource("drawable:coach_intro", setOf(
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/coach_intro.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/coach_intro.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/coach_intro.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_040_770_751)
public val Res.drawable.face_change: DrawableResource by lazy {
      DrawableResource("drawable:face_change", setOf(
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/face_change.jpg", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/face_change.jpg", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/face_change.jpg", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_036_585_170)
public val Res.drawable.fodmap_notification_icon_android: DrawableResource by lazy {
      DrawableResource("drawable:fodmap_notification_icon_android", setOf(
        ResourceItem(setOf(), "${MD}drawable/fodmap_notification_icon_android.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(583_191_730)
public val Res.drawable.fodmap_notification_icon_ios: DrawableResource by lazy {
      DrawableResource("drawable:fodmap_notification_icon_ios", setOf(
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/fodmap_notification_icon_ios.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/fodmap_notification_icon_ios.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/fodmap_notification_icon_ios.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(556_793_459)
public val Res.drawable.goal_is_a_wish: DrawableResource by lazy {
      DrawableResource("drawable:goal_is_a_wish", setOf(
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/goal_is_a_wish.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/goal_is_a_wish.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/goal_is_a_wish.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(549_455_480)
public val Res.drawable.happy_users: DrawableResource by lazy {
      DrawableResource("drawable:happy_users", setOf(
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/happy_users.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/happy_users.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/happy_users.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_289_343_337)
public val Res.drawable.happy_users_31: DrawableResource by lazy {
      DrawableResource("drawable:happy_users_31", setOf(
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/happy_users_31.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/happy_users_31.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/happy_users_31.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-344_214_476)
public val Res.drawable.happy_women_4_0: DrawableResource by lazy {
      DrawableResource("drawable:happy_women_4_0", setOf(
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/happy_women_4_0.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/happy_women_4_0.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/happy_women_4_0.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(476_518_385)
public val Res.drawable.image_vp_applle_signin: DrawableResource by lazy {
      DrawableResource("drawable:image_vp_applle_signin", setOf(
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/image_vp_applle_signin.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/image_vp_applle_signin.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/image_vp_applle_signin.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_962_666_178)
public val Res.drawable.img_carniinfo: DrawableResource by lazy {
      DrawableResource("drawable:img_carniinfo", setOf(
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/img_carniinfo.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/img_carniinfo.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/img_carniinfo.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_966_477_545)
public val Res.drawable.img_harshreality: DrawableResource by lazy {
      DrawableResource("drawable:img_harshreality", setOf(
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/img_harshreality.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/img_harshreality.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/img_harshreality.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-36_348_602)
public val Res.drawable.life_notification_icon_android: DrawableResource by lazy {
      DrawableResource("drawable:life_notification_icon_android", setOf(
        ResourceItem(setOf(), "${MD}drawable/life_notification_icon_android.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_561_603_308)
public val Res.drawable.life_notification_icon_ios: DrawableResource by lazy {
      DrawableResource("drawable:life_notification_icon_ios", setOf(
        ResourceItem(setOf(), "${MD}drawable/life_notification_icon_ios.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_123_821_324)
public val Res.drawable.losing_is_challenge: DrawableResource by lazy {
      DrawableResource("drawable:losing_is_challenge", setOf(
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/losing_is_challenge.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/losing_is_challenge.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/losing_is_challenge.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_205_451_791)
public val Res.drawable.ltr_chart: DrawableResource by lazy {
      DrawableResource("drawable:ltr_chart", setOf(
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/ltr_chart.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/ltr_chart.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/ltr_chart.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(469_233_789)
public val Res.drawable.ltr_header: DrawableResource by lazy {
      DrawableResource("drawable:ltr_header", setOf(
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/ltr_header.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/ltr_header.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/ltr_header.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_524_860_114)
public val Res.drawable.man_faces: DrawableResource by lazy {
      DrawableResource("drawable:man_faces", setOf(
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/man_faces.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/man_faces.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/man_faces.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_122_430_458)
public val Res.drawable.med_chart: DrawableResource by lazy {
      DrawableResource("drawable:med_chart", setOf(
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/med_chart.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/med_chart.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/med_chart.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-508_833_231)
public val Res.drawable.med_notification_icon_android: DrawableResource by lazy {
      DrawableResource("drawable:med_notification_icon_android", setOf(
        ResourceItem(setOf(), "${MD}drawable/med_notification_icon_android.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(425_016_068)
public val Res.drawable.med_notification_icon_ios: DrawableResource by lazy {
      DrawableResource("drawable:med_notification_icon_ios", setOf(
        ResourceItem(setOf(), "${MD}drawable/med_notification_icon_ios.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_081_406_784)
public val Res.drawable.onboarding_summary_bg: DrawableResource by lazy {
      DrawableResource("drawable:onboarding_summary_bg", setOf(
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/onboarding_summary_bg.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/onboarding_summary_bg.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/onboarding_summary_bg.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_968_537_210)
public val Res.drawable.paywall_config_13pro_v5: DrawableResource by lazy {
      DrawableResource("drawable:paywall_config_13pro_v5", setOf(
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/paywall_config_13pro_v5.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_136_051_596)
public val Res.drawable.paywall_config_14pro_v5: DrawableResource by lazy {
      DrawableResource("drawable:paywall_config_14pro_v5", setOf(
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/paywall_config_14pro_v5.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_466_966_208)
public val Res.drawable.paywall_config_low_v5: DrawableResource by lazy {
      DrawableResource("drawable:paywall_config_low_v5", setOf(
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/paywall_config_low_v5.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-189_281_773)
public val Res.drawable.paywall_config_mid_v5: DrawableResource by lazy {
      DrawableResource("drawable:paywall_config_mid_v5", setOf(
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/paywall_config_mid_v5.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_520_355_171)
public val Res.drawable.paywall_config_plus_v5: DrawableResource by lazy {
      DrawableResource("drawable:paywall_config_plus_v5", setOf(
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/paywall_config_plus_v5.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-652_866_218)
public val Res.drawable.paywall_config_promax_v5: DrawableResource by lazy {
      DrawableResource("drawable:paywall_config_promax_v5", setOf(
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/paywall_config_promax_v5.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_214_200_687)
public val Res.drawable.paywall_config_v5: DrawableResource by lazy {
      DrawableResource("drawable:paywall_config_v5", setOf(
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/paywall_config_v5.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/paywall_config_v5.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/paywall_config_v5.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_121_341_546)
public val Res.drawable.pcos_chart: DrawableResource by lazy {
      DrawableResource("drawable:pcos_chart", setOf(
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/pcos_chart.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/pcos_chart.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/pcos_chart.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(563_946_623)
public val Res.drawable.pcos_notification_icon_android: DrawableResource by lazy {
      DrawableResource("drawable:pcos_notification_icon_android", setOf(
        ResourceItem(setOf(), "${MD}drawable/pcos_notification_icon_android.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(25_217_520)
public val Res.drawable.pcos_notification_icon_ios: DrawableResource by lazy {
      DrawableResource("drawable:pcos_notification_icon_ios", setOf(
        ResourceItem(setOf(), "${MD}drawable/pcos_notification_icon_ios.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(12_897_239)
public val Res.drawable.pilates_chart: DrawableResource by lazy {
      DrawableResource("drawable:pilates_chart", setOf(
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/pilates_chart.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/pilates_chart.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/pilates_chart.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_121_735_290)
public val Res.drawable.pilates_notification_icon_android: DrawableResource by lazy {
      DrawableResource("drawable:pilates_notification_icon_android", setOf(
        ResourceItem(setOf(), "${MD}drawable/pilates_notification_icon_android.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_030_697_850)
public val Res.drawable.pilates_notification_icon_ios: DrawableResource by lazy {
      DrawableResource("drawable:pilates_notification_icon_ios", setOf(
        ResourceItem(setOf(), "${MD}drawable/pilates_notification_icon_ios.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(344_504_710)
public val Res.drawable.plus_size_girl_with_red_hair_right_4_0: DrawableResource by lazy {
      DrawableResource("drawable:plus_size_girl_with_red_hair_right_4_0", setOf(
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/plus_size_girl_with_red_hair_right_4_0.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/plus_size_girl_with_red_hair_right_4_0.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/plus_size_girl_with_red_hair_right_4_0.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-766_805_037)
public val Res.drawable.review: DrawableResource by lazy {
      DrawableResource("drawable:review", setOf(
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/review.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/review.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/review.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-213_727_255)
public val Res.drawable.review_image_men: DrawableResource by lazy {
      DrawableResource("drawable:review_image_men", setOf(
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/review_image_men.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/review_image_men.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/review_image_men.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(379_772)
public val Res.drawable.review_image_women: DrawableResource by lazy {
      DrawableResource("drawable:review_image_women", setOf(
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/review_image_women.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/review_image_women.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/review_image_women.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_128_345_735)
public val Res.drawable.rice_notification_icon_android: DrawableResource by lazy {
      DrawableResource("drawable:rice_notification_icon_android", setOf(
        ResourceItem(setOf(), "${MD}drawable/rice_notification_icon_android.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-902_486_567)
public val Res.drawable.rice_notification_icon_ios: DrawableResource by lazy {
      DrawableResource("drawable:rice_notification_icon_ios", setOf(
        ResourceItem(setOf(), "${MD}drawable/rice_notification_icon_ios.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-452_420_437)
public val Res.drawable.simple_recipes: DrawableResource by lazy {
      DrawableResource("drawable:simple_recipes", setOf(
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/simple_recipes.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/simple_recipes.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/simple_recipes.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(751_709_485)
public val Res.drawable.slow_down_aging: DrawableResource by lazy {
      DrawableResource("drawable:slow_down_aging", setOf(
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/slow_down_aging.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/slow_down_aging.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/slow_down_aging.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(190_206_714)
public val Res.drawable.woman_before_after: DrawableResource by lazy {
      DrawableResource("drawable:woman_before_after", setOf(
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/woman_before_after.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/woman_before_after.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/woman_before_after.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(150_333_549)
public val Res.drawable.woman_faces: DrawableResource by lazy {
      DrawableResource("drawable:woman_faces", setOf(
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/woman_faces.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/woman_faces.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/woman_faces.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(866_016_054)
public val Res.drawable.womanman_man: DrawableResource by lazy {
      DrawableResource("drawable:womanman_man", setOf(
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/womanman_man.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/womanman_man.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/womanman_man.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_004_242_955)
public val Res.drawable.womanman_woman: DrawableResource by lazy {
      DrawableResource("drawable:womanman_woman", setOf(
        ResourceItem(setOf(DensityQualifier.XHDPI, ), "${MD}drawable-xhdpi/womanman_woman.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXHDPI, ), "${MD}drawable-xxhdpi/womanman_woman.png", -1, -1),
        ResourceItem(setOf(DensityQualifier.XXXHDPI, ), "${MD}drawable-xxxhdpi/womanman_woman.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("almost_done", Res.drawable.almost_done)
  map.put("bland_notification_icon_android", Res.drawable.bland_notification_icon_android)
  map.put("bland_notification_icon_ios", Res.drawable.bland_notification_icon_ios)
  map.put("calc_plan_header", Res.drawable.calc_plan_header)
  map.put("cali_notification_icon_android", Res.drawable.cali_notification_icon_android)
  map.put("cali_notification_icon_ios", Res.drawable.cali_notification_icon_ios)
  map.put("carnivore_notification_icon_android", Res.drawable.carnivore_notification_icon_android)
  map.put("carnivore_notification_icon_ios", Res.drawable.carnivore_notification_icon_ios)
  map.put("chef_w", Res.drawable.chef_w)
  map.put("coach_intro", Res.drawable.coach_intro)
  map.put("face_change", Res.drawable.face_change)
  map.put("fodmap_notification_icon_android", Res.drawable.fodmap_notification_icon_android)
  map.put("fodmap_notification_icon_ios", Res.drawable.fodmap_notification_icon_ios)
  map.put("goal_is_a_wish", Res.drawable.goal_is_a_wish)
  map.put("happy_users", Res.drawable.happy_users)
  map.put("happy_users_31", Res.drawable.happy_users_31)
  map.put("happy_women_4_0", Res.drawable.happy_women_4_0)
  map.put("image_vp_applle_signin", Res.drawable.image_vp_applle_signin)
  map.put("img_carniinfo", Res.drawable.img_carniinfo)
  map.put("img_harshreality", Res.drawable.img_harshreality)
  map.put("life_notification_icon_android", Res.drawable.life_notification_icon_android)
  map.put("life_notification_icon_ios", Res.drawable.life_notification_icon_ios)
  map.put("losing_is_challenge", Res.drawable.losing_is_challenge)
  map.put("ltr_chart", Res.drawable.ltr_chart)
  map.put("ltr_header", Res.drawable.ltr_header)
  map.put("man_faces", Res.drawable.man_faces)
  map.put("med_chart", Res.drawable.med_chart)
  map.put("med_notification_icon_android", Res.drawable.med_notification_icon_android)
  map.put("med_notification_icon_ios", Res.drawable.med_notification_icon_ios)
  map.put("onboarding_summary_bg", Res.drawable.onboarding_summary_bg)
  map.put("paywall_config_13pro_v5", Res.drawable.paywall_config_13pro_v5)
  map.put("paywall_config_14pro_v5", Res.drawable.paywall_config_14pro_v5)
  map.put("paywall_config_low_v5", Res.drawable.paywall_config_low_v5)
  map.put("paywall_config_mid_v5", Res.drawable.paywall_config_mid_v5)
  map.put("paywall_config_plus_v5", Res.drawable.paywall_config_plus_v5)
  map.put("paywall_config_promax_v5", Res.drawable.paywall_config_promax_v5)
  map.put("paywall_config_v5", Res.drawable.paywall_config_v5)
  map.put("pcos_chart", Res.drawable.pcos_chart)
  map.put("pcos_notification_icon_android", Res.drawable.pcos_notification_icon_android)
  map.put("pcos_notification_icon_ios", Res.drawable.pcos_notification_icon_ios)
  map.put("pilates_chart", Res.drawable.pilates_chart)
  map.put("pilates_notification_icon_android", Res.drawable.pilates_notification_icon_android)
  map.put("pilates_notification_icon_ios", Res.drawable.pilates_notification_icon_ios)
  map.put("plus_size_girl_with_red_hair_right_4_0", Res.drawable.plus_size_girl_with_red_hair_right_4_0)
  map.put("review", Res.drawable.review)
  map.put("review_image_men", Res.drawable.review_image_men)
  map.put("review_image_women", Res.drawable.review_image_women)
  map.put("rice_notification_icon_android", Res.drawable.rice_notification_icon_android)
  map.put("rice_notification_icon_ios", Res.drawable.rice_notification_icon_ios)
  map.put("simple_recipes", Res.drawable.simple_recipes)
  map.put("slow_down_aging", Res.drawable.slow_down_aging)
  map.put("woman_before_after", Res.drawable.woman_before_after)
  map.put("woman_faces", Res.drawable.woman_faces)
  map.put("womanman_man", Res.drawable.womanman_man)
  map.put("womanman_woman", Res.drawable.womanman_woman)
}
